/** Avatar initials from a first and last name, e.g. ("Jane", "Doe") → "JD". "?" when both are blank. */
export function initials(
  first: string | null | undefined,
  last: string | null | undefined,
): string {
  return ((first?.[0] ?? '') + (last?.[0] ?? '')).toUpperCase() || '?';
}

/** Avatar initials from a single display name, e.g. "Jane Doe" → "JD". */
export function initialsFromName(name: string | null | undefined): string {
  const parts = (name ?? '').trim().split(/\s+/);
  return initials(parts[0], parts[1]);
}
